import {
  INTERNAL_SERVER_ERROR,
  EXPECTATION_FAILED,
} from "../constants/httpStatuses";
import { Error, ErrorResponse } from "../types/error-types";

const unknownError: Error = {
  message: "Unknown error",
  errors: ["Unknown"],
};

export const processError = (errorResponse: ErrorResponse): Error => {
  if (!errorResponse) {
    return unknownError;
  }

  if (errorResponse.response?.data) {
    const { status } = errorResponse.response;

    if (status >= INTERNAL_SERVER_ERROR) {
      return {
        errors: [errorResponse.response.data.error || "Server Error"],
        message: status.toString(),
      };
    }

    if (status === EXPECTATION_FAILED) {
      return {
        errors: [],
        message: status.toString(),
      };
    }

    return errorResponse.response.data as Error;
  }

  if (errorResponse.status && errorResponse.status >= INTERNAL_SERVER_ERROR) {
    return {
      errors: [errorResponse.error || "Server Error"],
      message: errorResponse.status.toString(),
    };
  }

  return unknownError;
};
